<template>
    <div class="all">
      <my-title :msg="title"></my-title>
      <el-form ref="form" :model="form" label-width="200px">
        <el-form-item label="申请人姓名">
          <el-input v-model="form.name" style="width: 400px;" :disabled="status == 1"></el-input>
        </el-form-item>
        <el-form-item label="申请人手机号">
          <el-input v-model="form.phone" style="width: 400px;" :disabled="status == 1"></el-input>
        </el-form-item>
        <el-form-item label="申请公司名称">
          <el-input v-model="form.pany_name" style="width: 400px;" :disabled="status == 1"></el-input>
        </el-form-item>
        <el-form-item label="申请公司详细地址">
          <el-input type="textarea" v-model="form.add_ress" style="width: 400px;" :disabled="status == 1"></el-input>
        </el-form-item>
        <el-form-item label="贵公司员工数量：">
          <el-radio-group v-model="form.play_num" :disabled="status == 1">
            <el-radio label="50人以下"></el-radio>
            <el-radio label="100~200人"></el-radio>
            <el-radio label="200~300人"></el-radio>
            <el-radio label="300~500人"></el-radio>
            <el-radio label="500~1000人"></el-radio>
            <el-radio label="1000人以上"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="办公用品消耗量大约为：">
          <el-radio-group v-model="form.price" :disabled="status == 1">
            <el-radio label="200元以上"></el-radio>
            <el-radio label="200~500元"></el-radio>
            <el-radio label="500~1000元"></el-radio>
            <el-radio label="1000~5000元"></el-radio>
            <el-radio label="5000~10000元"></el-radio>
            <el-radio label="10000元以上"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="办公用品购买：">
          <el-radio-group v-model="form.office" :disabled="status == 1">
            <el-radio label="每月一次"></el-radio>
            <el-radio label="每季一次"></el-radio>
            <el-radio label="每年一次"></el-radio>
            <el-radio label="不定期"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="采购办公用品采用的方式：">
          <el-radio-group v-model="form.sing" :disabled="status == 1">
            <el-radio label="外出采购"></el-radio>
            <el-radio label="电话采购"></el-radio>
            <el-radio label="网上订购"></el-radio>
            <el-radio label="其他"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" v-if="status == 1" disabled>已申请</el-button>
          <el-button type="primary" @click="onSubmit" v-else>申请月结</el-button>
        </el-form-item>
      </el-form>
    </div>
</template>

<script>
  import {getmonthly,getstatem} from '../api/Mycen'
    export default {
        name: "yuejie",
        data(){
          return{
            title:'申请月结',
            form: {
              name:'',
              phone:'',
              pany_name:'',
              play_num:'',
              add_ress:'',
              price:'',
              office:'',
              sing:'',
            },
            status:''
          }
        },
        mounted() {
          this.init()
        },
        methods:{
          init(){
            getstatem({}).then(res=>{
              this.status = res.type
              this.form = res.result
            })
          },
          onSubmit() {
            console.log(this.form);
            getmonthly(this.form).then(res=>{
              this.init()
            })
          }
        }
    }
</script>

<style scoped lang="less">
  @import "css/yuejie";
</style>



// WEBPACK FOOTER //
// src/components/yuejie.vue